import { render, staticRenderFns } from "./TabProducts.vue?vue&type=template&id=5f226e74&scoped=true&"
import script from "./TabProducts.vue?vue&type=script&lang=js&"
export * from "./TabProducts.vue?vue&type=script&lang=js&"
import style0 from "./TabProducts.vue?vue&type=style&index=0&id=5f226e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f226e74",
  null
  
)

export default component.exports